<div class="cb-margin">
    <mat-card class="cb-margin-bottom flex-col">
        <mat-card-content>
            <form #form="ngForm">
                <div class="start-center flex-row flex">
                    <mat-icon>search</mat-icon>
                    <cb-input
                        type="text"
                        label="Search"
                        [(ngModel)]="searchFiltersCache.data.query"
                        (ngModelChange)="searchFiltersChanged$.next($event)"
                        name="search"
                        class="cb-margin-left cb-margin-right-2x flex"
                    >
                    </cb-input>
                    <span class="flex"></span>
                    <cb-button class="cb-margin" (clicked)="createRevision()">
                        Create Revision
                    </cb-button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
    <div
        class="scroll-container"
        [cbInfiniteScroll]="listContainer"
        [fetch]="fetchResults()"
        *cbWaitFor="cacheLoaded$ | async"
        [queryUpdated]="searchFiltersChanged$"
        [enabled]="searchEnabled$"
        [(results)]="results"
        [(currentPage)]="currentPage"
    >
        <div #listContainer class="list-container flex-wrap xs-column flex">
            @if (results == null) {
                <cb-loading-spinner message="Fetching results"> </cb-loading-spinner>
            }
            @if (results != null && results.length == 0) {
                <cb-info-message
                    [message]="'There were no Price Revisions found'"
                    [icon]="'info_circle'"
                ></cb-info-message>
            }
            @for (result of results; track result) {
                <div class="flex-col xs-100 flex-25">
                    <cb-pricing-revision-card
                        class="flex"
                        [mappedItem]="result"
                        (viewClick)="viewPricingRevision($event)"
                    >
                    </cb-pricing-revision-card>
                </div>
            }
        </div>
    </div>
</div>
